import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoRadRelatorioPesquisaPreFaturaUnidata({
  payload,
}) {
  try {
    const { params } = payload;
    const response = yield call(
      api.get,
      'radrelatoriopesquisaprefaturaunidata',
      {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      }
    );
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoRadRelatorioPesquisaPreFaturaUnidata({
  payload,
}) {
  try {
    const { fatu_codigo, params } = payload;

    yield call(
      api.delete,
      `radrelatoriopesquisaprefaturaunidata/${fatu_codigo}`
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoradrelatoriopesquisaprefaturaunidata, params } = payload;

    yield call(
      api.post,
      'radrelatoriopesquisaprefaturaunidata',
      operacaoradrelatoriopesquisaprefaturaunidata
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/radrelatoriopesquisaprefaturaunidata');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { fatu_codigo } = payload;

    const { data } = yield call(
      api.get,
      `radpesquisaprefaturaunidata/${fatu_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoradrelatoriopesquisaprefaturaunidata, params } = payload;

    yield call(
      api.put,
      'radrelatoriopesquisaprefaturaunidata',
      operacaoradrelatoriopesquisaprefaturaunidata
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/radrelatoriopesquisaprefaturaunidata');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(
      api.get,
      'radrelatoriopesquisaprefaturaunidata',
      {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      }
    );

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoradrelatoriopesquisaprefaturaunidata/OPERACAORADRELATORIOPESQUISAPREFATURAUNIDATA_IN_REQUEST',
    requestOperacaoRadRelatorioPesquisaPreFaturaUnidata
  ),
  takeLatest(
    '@operacaoradrelatoriopesquisaprefaturaunidata/DELETE_OPERACAORADRELATORIOPESQUISAPREFATURAUNIDATA',
    deleteOperacaoRadRelatorioPesquisaPreFaturaUnidata
  ),
  takeLatest(
    '@operacaoradrelatoriopesquisaprefaturaunidata/SUCCESS_REMOVE',
    requestOperacaoRadRelatorioPesquisaPreFaturaUnidata
  ),
  takeLatest(
    '@operacaoradrelatoriopesquisaprefaturaunidata/STORE_OPERACAORADRELATORIOPESQUISAPREFATURAUNIDATA',
    store
  ),
  takeLatest(
    '@operacaoradrelatoriopesquisaprefaturaunidata/FIND_OPERACAORADRELATORIOPESQUISAPREFATURAUNIDATA',
    find
  ),
  takeLatest(
    '@operacaoradrelatoriopesquisaprefaturaunidata/UPDATE_OPERACAORADRELATORIOPESQUISAPREFATURAUNIDATA',
    update
  ),
  takeLatest(
    '@operacaoradrelatoriopesquisaprefaturaunidata/RECORD_FILTERING',
    applyedFilters
  ),
]);
